import React, { useState } from 'react';
import { ordersStore } from '../../stores';
import { ViewMoreDesign } from '../../pages/Catalogue';

const ViewMoreDesignContainer = () => {
	const [loading, setLoading] = useState(false);
	const [selectedImage, setSelectedImage] = useState(0);
	const [amount, setAmount] = useState(0);
	const [requestModal, setRequestModal] = useState(false);

	const handleClick = id => {
		setSelectedImage(id);
	};
	const design = ordersStore.design;

	const goToRequestModal = () => {
		setRequestModal(true);
	};

	const closeModal = () => {
		setRequestModal(false);
	};

	return (
		<ViewMoreDesign
			designList={design}
			loading={loading}
			amount={amount}
			setAmount={setAmount}
			selectedImage={selectedImage}
			handleClick={handleClick}
			goToRequestModal={goToRequestModal}
			closeModal={closeModal}
			requestModal={requestModal}
		/>
	);
};

export default ViewMoreDesignContainer;
